var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10.0364L6 12L7.5 10.0364H10.3158C11.246 10.0364 12 9.2549 12 8.29091V1.74545C12 0.781467 11.246 0 10.3158 0H1.68421C0.754047 0 0 0.781467 0 1.74545V8.29091C0 9.2549 0.754047 10.0364 1.68421 10.0364H4.5ZM6 10.9455L7.19446 9.38182H10.3158C10.8971 9.38182 11.3684 8.8934 11.3684 8.29091V1.74545C11.3684 1.14296 10.8971 0.654545 10.3158 0.654545H1.68421C1.10286 0.654545 0.631579 1.14296 0.631579 1.74545V8.29091C0.631579 8.8934 1.10286 9.38182 1.68421 9.38182H4.80554L6 10.9455Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.31592,
    y: 2.61816,
    width: 7.1579,
    height: 1.09091,
    rx: 0.545455,
    fill: "#BDBDBD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.31592,
    y: 4.36328,
    width: 7.1579,
    height: 1.09091,
    rx: 0.545455,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.31592,
    y: 6.10938,
    width: 4.42105,
    height: 1.09091,
    rx: 0.545455,
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComment);
export default __webpack_public_path__ + "static/media/ic-comment.6b9954fbe6488b2dcc553b2f27717146.svg";
export { ForwardRef as ReactComponent };